/* React */
import React, { useRef, useState, useMemo } from "react";

/* Ionic */
import {
  IonItem,
  IonIcon,
  // InputInputEventDetail,
} from "@ionic/react";

// import type { IonInputCustomEvent } from "@ionic/core";
import { chevronDown, chevronUp } from "ionicons/icons";

/* Utils */
import useClickOutsideHandler from "src/utils/hooks/useClickOutsideHandler";

/* Components */
import DropdownContainer from "src/components/shared/simple-select/dropdown-container/DropdownContainer";

/* Stylesheet */
import styles from "./SimpleSelect.module.scss";

/* Interfaces */
import { SimpleSelectProps } from "src/shared/interfaces/common/SimpleSelect";

const SimpleSelect = <T,>({
  className,
  // label,
  placeholder,
  value,
  items,
  disabled,
  getLabel,
  onSelect,
}: SimpleSelectProps<T>) => {
  const dropdownRef = useRef<HTMLDivElement>(null);

  const [showItems, setShowItems] =
    useState<boolean>(false);

  // const [showSearchbar, setShowSearchbar] =
  //   useState<boolean>(false);

  const [searchTerm, setSearchTerm] = useState<string>("");

  useClickOutsideHandler({
    ref: dropdownRef,
    onClick: () => setShowItems(false),
  });

  const selectedItem = items.find(
    (item) => getLabel(item) === value
  );
  /* Compared against undefined, which is what `find` returns when nothing
     matched. A truthiness test loses any item that is itself falsy — the
     assistant's model picker uses `null` for "let the deployment choose",
     and it showed the placeholder instead of that option's label. */
  const selectedLabel =
    selectedItem !== undefined
      ? getLabel(selectedItem)
      : placeholder;

  const visibleItems = useMemo(() => {
    return items
      .filter((item) => getLabel(item) !== selectedLabel)
      .filter((item) =>
        getLabel(item)
          .toLowerCase()
          .includes(searchTerm.toLowerCase())
      );
  }, [items, selectedLabel, getLabel, searchTerm]);

  // const handleSearchTerm = (
  //   e: IonInputCustomEvent<InputInputEventDetail>
  // ) => {
  //   setSearchTerm(e.target.value as string);
  // };

  return (
    <div ref={dropdownRef} className={styles.simple_select}>
      <IonItem
        style={{
          "--border-radius": showItems
            ? "5px 5px 0px 0px"
            : "46px",
        }}
        className={`${styles.item} ${
          styles[className ?? ""]
        }`}
        lines="none"
        button
        disabled={disabled}
        onClick={() => {
          setShowItems((prev) => !prev);
        }}
      >
        <div className={styles.value}>{selectedLabel}</div>
        <IonIcon
          className={styles.icon}
          icon={showItems ? chevronUp : chevronDown}
          slot="end"
        />
      </IonItem>
      {showItems ? (
        <DropdownContainer
          className={className}
          items={visibleItems}
          getLabel={getLabel}
          onSelect={(item) => {
            onSelect(item);
            setShowItems(false);
            setSearchTerm("");
          }}
        />
      ) : undefined}
    </div>
  );
};

export default SimpleSelect;
